import clsx from 'clsx'
import React, { CSSProperties, FC } from 'react'

import styles from './checkboxIndicator.module.scss'

interface Styles extends CSSProperties {
  boxColor?: string
  checkedBoxColor?: string
  checkedIndicationColor?: string
  checkedInnerColor?: string
  indicationColor?: string
  innerColor?: string
}
export interface CheckboxIndicatorProps {
  checked?: boolean
  className?: string
  round?: boolean
  style?: Styles
}

export const CheckboxIndicator: FC<CheckboxIndicatorProps> = ({ checked, className, round, style }) => {
  const exStyles: CSSProperties | undefined = (style
    ? {
      '--indicationColor': style?.indicationColor || 'var(--neutral-100)',
      '--checkedIndicationColor': style?.checkedIndicationColor || 'var(--black)',
      '--borderColor': style?.boxColor || 'var(--black)',
      '--checkedBorderColor': style?.checkedBoxColor || style?.boxColor || 'var(--black)',
      '--backgroundColor': style?.innerColor || 'var(--neutral-100)',
      '--checkedBackgroundColor': style?.checkedInnerColor || style?.innerColor || 'var(--neutral-100)',
      ...style,
    } as CSSProperties
    : style)
  return (
    <div className={clsx('checkboxIndicator', round && styles.round, styles.checkboxIndicator, checked && styles.checked, className)} style={exStyles}>
      <span className={clsx('checkboxIndicatorMark', styles.mark, round && styles.round)} />
    </div>
  )
}

